import { useMemo } from "react";
import { useL500Token } from "./useL500Token";
import { decodeL500Token } from "./decodeL500Token";
export function usePermissionKeys() {
    const token = useL500Token();
    return useMemo(() => {
        if (!token)
            return [];
        const decoded = decodeL500Token(token);
        return decoded?.permissions ?? [];
    }, [token]);
}
//# sourceMappingURL=usePermissionKeys.js.map